<div class="flex items-center gap-2">
  <app-button (onChangeClick)="onStartChat()">
    <span class="flex items-center gap-1.5">
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">add</app-icon>
      {{ 'start_chat' | translate }}
    </span>
  </app-button>
  <app-button
    btnType="stroked"
    [disabled]="linking"
    (onChangeClick)="onLinkExistingChat()"
  >
    <span class="flex items-center gap-1.5">
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-slate-400">chat_bubble_outline</app-icon>
      {{ 'link_existing_chat' | translate }}
    </span>
    
  </app-button>
</div>

<div class="mt-3 flex flex-col gap-1">
  @if (loading) {
    <div class="flex min-h-24 items-center justify-center">
      <app-loader />
    </div>
  } @else {
    @for (chat of chatItems; track chat.id) {
      <app-chat-list-item
        class="cursor-pointer"
        [chat]="chat"
        [cardId]="cardId"
        [selected]="false"
        (click)="onOpenChat(chat)"
        (onActionEmit)="onChatAction($event)"
      />
    } @empty {
      <div class="flex min-h-24 items-center justify-center rounded-lg bg-slate-50 text-sm text-slate-400">
        {{ 'no_chats' | translate }}
      </div>
    }
  }
</div>
